<template>
  <el-dialog class="customDialog tileAttribute" :title="uiType===0?'新增':'编辑'" :visible.sync="isShow" :modal="false" :close-on-press-escape = 'false' :close-on-click-modal="false" @close="onClose">
    <div class="formContainer">
      <el-form :inline="true" :model="formInline" :rules="rules" ref="form" class="demo-form-inline">
      <el-form-item label="模型名称：" prop="name">
        <el-input class="form-input" v-model="formInline.name" placeholder="请输入20字以内" :maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="模型类型：" prop="type">
        <el-select class="form-input" v-model="formInline.type" placeholder="请选择" >
          <el-option v-for="item in tileTypeOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模型精度：" prop="level">
        <el-select class="form-input" v-model="formInline.level" placeholder="请选择" >
          <el-option v-for="item in levelOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="面积：" prop="area">
        <el-input class="form-input" v-model="formInline.area" placeholder="请输入" >
          <div class="append-icon" slot="suffix">km²</div>
        </el-input>
      </el-form-item>
      <el-form-item label="模型高度：" prop="initHeight" v-if="formInline.type==='THREE_DIMENSIONS'">
        <el-input class="form-input" v-model="formInline.initHeight" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item label="切片方案：" prop="tilingScheme" v-if="formInline.type==='TWO_DIMENSIONS'">
        <el-select class="form-input" v-model="formInline.tilingScheme" placeholder="请选择" >
          <el-option v-for="item in tilingSchemeOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模型链接：" prop="url" class="row">
        <el-input v-model="formInline.url" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item label="备注：" class="row">
        <el-input v-model="formInline.notes" type="textarea" :maxlength="255" show-word-limit placeholder="请输入" >
        </el-input>
      </el-form-item>
      <!-- <div class="divider"></div>
      <div class="header-pos">初始定位点</div>
      <el-form-item label="经度：" prop="lon">
        <el-input class="form-input" v-model="formInline.lon" placeholder="请输入" >
          <div class="append-icon" slot="suffix">°</div>
        </el-input>
      </el-form-item>
      <el-form-item label="纬度：" prop="lat">
        <el-input class="form-input" v-model="formInline.lat" placeholder="请输入" >
          <div class="append-icon" slot="suffix">°</div>
        </el-input>
      </el-form-item>
      <el-form-item label="高度：" prop="height">
        <el-input class="form-input" v-model="formInline.height" placeholder="请输入" >
          <div class="append-icon" slot="suffix">m</div>
        </el-input>
      </el-form-item> -->
    </el-form>
    </div>
    <span slot="footer">
      <el-button type="default" @click="onClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { validateNumber, validateURL, validateLongitude, validateLatitude } from '@/utils/rules'
import { getModel, addModel, updateModel } from '@/api/model'
export default {
  name: 'TileAttribute',
  data () {
    return {
      isShow: false,
      // ui类型，0新增，1修改
      uiType: 0,
      title: '新增',
      formInline: {
        name: '',
        type: undefined,
        url: '',
        level: undefined,
        area: undefined,
        notes: '',
        lon: undefined,
        lat: undefined,
        height: undefined,
        initHeight: undefined,
        tilingScheme: undefined
      },
      rules: {
        name: [
          { required: true, message: '请输入模型名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择模型类型', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入模型地址链接', trigger: 'blur' },
          { validator: validateURL, trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择模型精度', trigger: 'blur' }
        ],
        area: [
          { validator: validateNumber, trigger: 'blur' }
        ],
        lon: [
          { required: true, message: '请输入相机定位经度', trigger: 'blur' },
          { validator: validateLongitude, trigger: 'blur' }
        ],
        lat: [
          { required: true, message: '请输入相机定位纬度', trigger: 'blur' },
          { validator: validateLatitude, trigger: 'blur' }
        ],
        height: [
          { required: true, message: '请输入相机定位高度', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        initHeight: [
          { required: true, message: '请输入模型高度', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        tilingScheme: [
          { required: true, message: '请选择切片方案', trigger: 'blur' }
        ]
      },
      // 瓦片类型
      tileTypeOptions: [
        { value: 'TWO_DIMENSIONS', name: '二维地图' },
        { value: 'THREE_DIMENSIONS', name: '三维地图' }
      ],
      // 精度类型
      levelOptions: [
        { value: 'ONE_TO_150', name: '1:150' },
        { value: 'ONE_TO_300', name: '1:300' },
        { value: 'ONE_TO_500', name: '1:500' },
        { value: 'ONE_TO_1000', name: '1:1000' },
        { value: 'ONE_TO_2000', name: '1:2000' }
      ],
      tilingSchemeOptions: [
        { value: 'WebMercatorTilingScheme', name: '墨卡托坐标(WebMercator)' },
        { value: 'GeographicTilingScheme', name: '经纬度坐标(Geographic)' }
        // { value: 'AmapMercatorTilingScheme', name: '国测局坐标(GCJ-02)' }
      ],
      loading: false
    }
  },
  mounted () {},
  methods: {
    open (id) {
      this.isShow = true
      if (id) {
        this.uiType = 1
        this.id = id
        this.getModelInfo()
      } else {
        this.uiType = 0
        this.id = undefined
      }
    },
    clear () {
      // this.$refs.form.resetFields()
      this.formInline = this.$options.data().formInline
      this.$refs.form.clearValidate()
    },
    onClose () {
      this.clear()
      this.isShow = false
    },
    // 获取模型信息
    getModelInfo () {
      getModel({
        id: this.id
      }).then(res => {
        if (res.code === 200) {
          const options = res.data
          this.formInline.id = options.id
          this.formInline.name = options.name
          this.formInline.type = options.type
          this.formInline.url = options.link
          this.formInline.level = options.dataPrecision
          this.formInline.area = options.area
          this.formInline.notes = options.remark
          this.formInline.lon = options.defaultLongitude
          this.formInline.lat = options.defaultLatitude
          this.formInline.height = options.defaultHeight
          this.formInline.initHeight = options.height
          this.formInline.tilingScheme = options.tilingScheme
        }
      })
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.uiType === 0) {
            addModel({
              area: this.formInline.area,
              dataPrecision: this.formInline.level,
              defaultHeight: this.formInline.height,
              defaultLongitude: this.formInline.lon,
              defaultLatitude: this.formInline.lat,
              link: this.formInline.url,
              name: this.formInline.name,
              remark: this.formInline.notes,
              type: this.formInline.type,
              height: this.formInline.initHeight,
              tilingScheme: this.formInline.tilingScheme
            }).then(res => {
              this.loading = false
              if (res.code === 200) {
                this.$Message('success', '提交模型成功')
                this.$emit('refresh')
                this.onClose()
              }
            }).catch(res => {
              this.loading = false
            })
          } else {
            updateModel({
              id: this.id,
              area: this.formInline.area,
              dataPrecision: this.formInline.level,
              defaultHeight: this.formInline.height,
              defaultLongitude: this.formInline.lon,
              defaultLatitude: this.formInline.lat,
              link: this.formInline.url,
              name: this.formInline.name,
              remark: this.formInline.notes,
              type: this.formInline.type,
              height: this.formInline.initHeight,
              tilingScheme: this.formInline.tilingScheme
            }).then(res => {
              this.loading = false
              if (res.code === 200) {
                this.$Message('success', '模型属性修改成功')
                this.$emit('refresh')
                this.onClose()
              }
            }).catch(res => {
              this.loading = false
            })
          }
        } else {
          // this.$Message('error', '提交数据格式错误')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tileAttribute {
  .form-input {
    width: 260px;
  }
  .form-input-long {
    width: 630px;
  }
  .header-pos{
    text-align: left;
    font-size: 16px;
    color: #FFFFFF;
    margin-left: 21px;
  }
  .el-dialog{
    width: 870px;
  }
  .el-form-item__label{
    width: 140px !important;
  }
}
</style>
